<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Sélection du professionnel de qualification</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-5 col"
					>Professionnels disponibles le
					{{ missionQualification.missionRequest.date | date : 'dd/MM/yy' }} à
					{{ missionQualification.missionRequest.readyTime }}</span
				>
			</div>
			<div class="row my-2">
				<div class="list-group">
					<button
						type="button"
						class="list-group-item list-group-item-action theme-main-color-button"
						*ngFor="let emp of employees"
						[ngClass]="{
							'theme-main-color-check text-white': selectedEmployee === emp
						}"
						[disabled]="isValidateButtonClicked"
						(click)="selectEmployee(emp)"
					>
						<span>
							{{
								emp.firstName + '  ' + emp.lastName + ' - ' + emp.address.label
							}}
						</span>
					</button>
				</div>
			</div>
			<div class="row my-5">
				<div class="d-flex justify-content-end">
					<button
						class="btn theme-main-color-button mx-3 px-3"
						type="button"
						(click)="bsModalRef.hide()"
					>
						Retour
					</button>
					<button
						[disabled]="!selectedEmployee || isValidateButtonClicked"
						class="btn theme-green-button"
						(click)="validateEmployee()"
					>
						<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
